import { render } from "./FormularioAcademy.vue?vue&type=template&id=0e3e1ce0&scoped=true&ts=true"
import script from "./FormularioAcademy.vue?vue&type=script&lang=ts"
export * from "./FormularioAcademy.vue?vue&type=script&lang=ts"

import "./FormularioAcademy.vue?vue&type=style&index=0&id=0e3e1ce0&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3e1ce0"]])

export default __exports__